// Module-level cache for ActivityCalendar data. The calendar tab is
// conditionally rendered inside the planner, so every tab re-entry remounts
// the component; without this cache each remount re-paid every visible
// month's activity fetch. Holds those months only — trips come from the
// planner's own list (usePlannerData). Mutations inside the calendar
// invalidate via invalidateCalendarCache.

const calendarCache = new Map(); // userId -> { data, ts }
const CALENDAR_TTL_MS = 60_000;

export const getCalendarCached = (userId) => {
  if (!userId) return null;
  const entry = calendarCache.get(userId);
  if (!entry) return null;
  if (Date.now() - entry.ts > CALENDAR_TTL_MS) {
    calendarCache.delete(userId);
    return null;
  }
  return entry.data;
};

export const setCalendarCached = (userId, data) => {
  if (!userId) return;
  calendarCache.set(userId, { data, ts: Date.now() });
};

export const invalidateCalendarCache = (userId) => {
  if (userId) calendarCache.delete(userId);
  else calendarCache.clear();
};
